import { integrationsApi } from './integrations-api.service';

/**
 * Integration service wrapper that provides the same interface as the original IntegrationService
 * but uses the new IntegrationsApi client underneath.
 */
class IntegrationService {
    /**
     * Get the list of integration providers.
     */
    async getProviders(appId: string): Promise<
        {
            id: string;
            name: string;
            available: boolean;
            icon: string;
        }[]
    > {
        try {
            return await integrationsApi.fetchProviders(appId);
        } catch (error) {
            console.error('Failed to fetch providers:', error);
            throw new Error('Failed to fetch providers');
        }
    }

    /**
     * Get the list of authorized providers for the current user.
     */
    async getAuthorizedProviders(): Promise<
        {
            _id: string;
            name: string;
            available: boolean;
            icon: string;
            authorization: {
                id: string;
                completed: boolean;
            };
        }[]
    > {
        try {
            return await integrationsApi.fetchAuthorizedProviders();
        } catch (error) {
            console.error('Failed to fetch authorized providers:', error);
            throw new Error('Failed to fetch authorized providers');
        }
    }

    /**
     * Authenticate with YPF.
     */
    async authorizeWithYPF(): Promise<{ token: string }> {
        try {
            return await integrationsApi.authorizeWithYPF();
        } catch (error) {
            console.error('Failed to authorize with YPF:', error);
            throw new Error('Failed to authorize with YPF');
        }
    }

    /**
     * Delete YPF authorization.
     */
    async deleteYpfAuthorization(): Promise<{ token: string }> {
        try {
            return await integrationsApi.deleteYpfAuthorization();
        } catch (error) {
            console.error('Failed to delete YPF authorization:', error);
            throw new Error('Failed to delete YPF authorization');
        }
    }

    /**
     * Delete Google Drive authorization.
     */
    async deleteGoogleAuth(): Promise<{ _id: string }> {
        try {
            return await integrationsApi.deleteGoogleAuth();
        } catch (error) {
            console.error('Failed to delete google auth:', error);
            throw new Error('Failed to delete google auth');
        }
    }
}

export const integrationService = new IntegrationService();
